// @ts-check
// Identidade da escola para desenhar os e-mails na tela (spec/email.md seções 7.5 e 9): cor, rodapé e motivo do envio
// de "Identidade e envio" (lidos uma vez por aba e atualizados quando o diálogo grava), nome e logo atual da escola.
import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';
import { getEmailSettings } from '../../data/email-templates.js';
import { sessionState } from '../../data/metadata-store.js';
import { DEFAULT_BRAND_COLOR } from '../../../../shared/email-design/render-email.js';
import { absoluteLogoUrl } from './local-preview.js';

/** @typedef {import('../../data/email-templates.js').EmailSettingsResponse} EmailSettingsResponse */

/** @type {import('@preact/signals').Signal<EmailSettingsResponse | null>} */
export const emailSettingsState = signal(null);
/** @type {Promise<EmailSettingsResponse | null> | null} */
let pendingSettings = null;

/** @param {{ force?: boolean }} [options] */
export function loadEmailSettings(options = {}) {
  if (emailSettingsState.value && !options.force) return Promise.resolve(emailSettingsState.value);
  if (!pendingSettings) {
    pendingSettings = getEmailSettings()
      .then((response) => {
        emailSettingsState.value = response;
        return response;
      })
      .catch(() => null)
      .finally(() => {
        pendingSettings = null;
      });
  }
  return pendingSettings;
}

/** @param {EmailSettingsResponse} response */
export function replaceEmailSettingsLocally(response) {
  emailSettingsState.value = response;
}

/** Nome, logo, cor e configuração da escola para os desenhos de e-mail. */
export function useEmailBranding() {
  useEffect(() => {
    loadEmailSettings();
  }, []);
  const tenant = /** @type {{ displayName?: string, logoUrl?: string | null, brandLogoUrl?: string | null } | undefined} */ (/** @type {any} */ (sessionState.value)?.tenant);
  const response = emailSettingsState.value;
  return {
    settings: response?.settings ?? null,
    response,
    brandColor: response?.settings.brandColor ?? DEFAULT_BRAND_COLOR,
    institutionName: tenant?.displayName ?? '',
    // o logo completo da identidade visual tem preferência sobre o ícone, como no envio
    logoUrl: absoluteLogoUrl(tenant?.brandLogoUrl || tenant?.logoUrl || null),
  };
}
